export enum SchoolContentSectionType {
  Course = "course",
  Library = "library",
}
